var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-fab md-primary",attrs:{"to":"/upload"}},[_c('md-icon',[_vm._v("upload")]),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("upload documentation")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }